export const SET_IS_OWNERSHIP_RESULTS_EXPANDED = 'SET_IS_OWNERSHIP_RESULTS_EXPANDED';

export const START_OWNERSHIP_SEARCH_REQUEST = 'START_OWNERSHIP_SEARCH_REQUEST';
export const START_OWNERSHIP_SEARCH_SUCCESS = 'START_OWNERSHIP_SEARCH_SUCCESS';
export const START_OWNERSHIP_SEARCH_FAILURE = 'START_OWNERSHIP_SEARCH_FAILURE';

export const FETCH_OWNERSHIP_SEARCH_REQUEST = 'FETCH_OWNERSHIP_SEARCH_REQUEST';
export const FETCH_OWNERSHIP_SEARCH_SUCCESS = 'FETCH_OWNERSHIP_SEARCH_SUCCESS';
export const FETCH_OWNERSHIP_SEARCH_FAILURE = 'FETCH_OWNERSHIP_SEARCH_FAILURE';

export const PING_OWNERSHIP_SEARCH_REQUEST = 'PING_OWNERSHIP_SEARCH_REQUEST';
export const PING_OWNERSHIP_SEARCH_SUCCESS = 'PING_OWNERSHIP_SEARCH_SUCCESS';
export const PING_OWNERSHIP_SEARCH_FAILURE = 'PING_OWNERSHIP_SEARCH_FAILURE';

export const CANCEL_OWNERSHIP_SEARCH_REQUEST = 'CANCEL_OWNERSHIP_SEARCH_REQUEST';
export const CANCEL_OWNERSHIP_SEARCH_SUCCESS = 'CANCEL_OWNERSHIP_SEARCH_SUCCESS';
export const CANCEL_OWNERSHIP_SEARCH_FAILURE = 'CANCEL_OWNERSHIP_SEARCH_FAILURE';

export const FETCH_OWNERSHIP_SEARCH_RESULTS_REQUEST = 'FETCH_OWNERSHIP_SEARCH_RESULTS_REQUEST';
export const FETCH_OWNERSHIP_SEARCH_RESULTS_SUCCESS = 'FETCH_OWNERSHIP_SEARCH_RESULTS_SUCCESS';
export const FETCH_OWNERSHIP_SEARCH_RESULTS_FAILURE = 'FETCH_OWNERSHIP_SEARCH_RESULTS_FAILURE';